import { createRouter, createWebHistory } from 'vue-router'
import PublishingOverview from '@/components/Overview/PublishingOverview.vue'
import MyWorks from '@/components/MyWorks/MyWorks.vue'
import AllSyncOps from '@/components/SyncOpportunities/AllSyncOps.vue'
import PickReleaseTab from '@/components/AddWork/PickReleaseTab.vue'
import AddWritersTab from '@/components/AddWork/AddWritersTab.vue'

const DASHBOARD_URL = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'

const routes = [
  { path: '/', name: 'PublishingOverview', component: PublishingOverview },
  { path: '/works', name: 'MyWorks', component: MyWorks },
  {
    path: '/works/create',
    name: 'PickReleaseTab',
    component: PickReleaseTab,
  },
  {
    path: '/works/create/:releaseId',
    name: 'AddWritersTab',
    component: AddWritersTab,
  },
  {
    path: '/sync-opportunities/:syncOpId?',
    name: 'SyncOpportunities',
    component: AllSyncOps,
    props: true,
  },
  {
    path: '/co-writers',
    name: 'CoWriters',
    redirect: '',
    beforeEnter: () => {
      window.location.href = `${DASHBOARD_URL}/publishing/co-writers`
    },
  },
]

export default createRouter({
  history: createWebHistory('/publishing'),
  linkActiveClass: 'active',
  linkExactActiveClass: 'act',
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})
